
import ManageProfile from "../../component/auth/ManageProfile";
import Page403 from "../../component/errors/Page403";
import Page404 from "../../component/errors/Page404";
import About from "../../component/frontend/About";
import ForgetPassword from "../../component/frontend/auth/ForgetPassword";
import ChangePassword from "../../component/frontend/auth/ChangePassword";
import Login from "../../component/frontend/auth/Login";
import Register from "../../component/frontend/auth/Register";
import Contact from "../../component/frontend/Contact";
import Details from "../../component/frontend/Details";
import FavoriteList from "../../component/frontend/Favorites";
import Help from "../../component/frontend/Help";
import Home from "../../component/frontend/Home";
import Privacy from "../../component/frontend/Privacy";
import Terms from "../../component/frontend/Terms";
import RenewSite from "../../component/frontend/RenewSite";
import RenewUser from "../../component/frontend/RenewUser";
import NearbyContractorListByUser from "../../component/frontend/NearbyContractorListByUser";
import MyPostList from "../../component/frontend/MyPostList";
import EditPostSite from "../../component/frontend/EditPostSite";

const Routes = [
    { path: '/', exact: true, name:'Home', component:Home },
    { path: '/register', exact: true, name:'Register', component: Register },
    { path: '/login', exact: true, name:'Login', component: Login },
    { path: '/manage-profile/:id', exact: true, name:'Profile', component: ManageProfile },
    { path: '/forget-password', exact: true, name:'Forget', component: ForgetPassword },
    { path: '/change-password', exact: true, name:'ChangePassword', component: ChangePassword },
    { path: '/favorite', exact: true, name:'Favorite', component: FavoriteList },
    { path: '/detail/:id', exact: true, name:'Details', component: Details },
    { path: '/page404', exact: true, name:'Page404', component: Page404 },
    { path: '/page403', exact: true, name:'Page403', component: Page403 },
    { path: '/about', exact: true, name:'About', component: About },
    { path: '/terms', exact: true, name:'Terms', component: Terms },
    { path: '/privacy', exact: true, name:'Privacy', component: Privacy },
    { path: '/contact', exact: true, name:'Contact', component: Contact },
    { path: '/renew-site', exact: true, name:'RenewSite', component: RenewSite },
    { path: '/renew-account', exact: true, name:'RenewUser', component: RenewUser },
    { path: '/nearby-posts', exact: true, name:'NearbyContractorListByUser', component: NearbyContractorListByUser },
    { path: '/my-posts', exact: true, name:'MyPostList', component: MyPostList },
    { path: '/edit-post/:id', exact: true, name:'EditPostSite', component: EditPostSite },
    

];


export default Routes;